module.exports = __webpack_public_path__ + "static/testimonials-f0bb9851f9d0bee9bb16ee6da20200e2.png";